/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Pencil } from '../../assets/themes/OPL/img/icons/Pencil.svg';

function EditButton({ ...props }) {
    const { classes, callback, callbackParam, color, text, icons, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={icons ?? Pencil}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

EditButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default EditButton;
